(function () {
	'use strict';

	angular
		.module('wizard-future7')
		.controller('DefaultQuizResultController', DefaultQuizResultController)

	/** @ngInject */
	function DefaultQuizResultController($state, $location, $sce, LeadService, NotifyService, HelperService) {
		const vm = this;
		let resultHash = $state.params.resultHash;

		vm.breakpoints = {
			2000: {
				slidesPerView: 1,
				spaceBetween: 0
			}
		}

		vm.onSelectSolution = (solution) => {
			$state.go(`default.home`, {
				solucao: solution
			});
		}

		vm.setSelectedVideo = videoId => vm.selectedVideo = vm.programs.find(el => el.Id == videoId)
		vm.getVideoFrame = url => $sce.trustAsResourceUrl(url);

		init();

		function getAstronaut(resultHash) {
			if (!resultHash) $state.go('default.quiz-intro');
			HelperService.startLoading(".quiz-container");

			LeadService.getLeadResult(resultHash).then(success => {
				if (success.Error) {
					$state.go('default.quiz-intro');
					HelperService.stopLoading(".quiz-container");
					return;
				}

				vm.selectedDummyParts = JSON.parse(success.Result.dummy);
				let resultQuestions = JSON.parse(success.Result.result);
				let programsFilter = vm.programs.filter(program => resultQuestions.includes(program.Id));
				let programsNew = programsFilter.reduce((total, program) => {
					program.ProgramSkills.map(skill => {
						total.push(skill);
					})
					return total
				}, []);

				vm.result = success.Result;
				vm.programsFilter = programsFilter;
				vm.programSkills = vm.skills.filter(skill => programsNew.includes(skill.Id));

				if (vm.programs.filter(program => !resultQuestions.includes(program.Id)).length) {
					vm.otherPrograms = vm.programs.filter(program => !resultQuestions.includes(program.Id));
				} else {
					vm.otherPrograms = vm.programs;
				}

				HelperService.stopLoading(".quiz-container");

			}).catch(error => {
				NotifyService
					.notify({
						type: 'error',
						title: 'Ops!',
						text: 'Ocorreu um erro ao obter os Dados',
						showConfirmButton: true,
						confirmButtonText: 'Tentar novamente',
						showCancelButton: false,
						allowEscapeKey: false,
						allowOutsideClick: false
					}, getAstronaut);
				HelperService.stopLoading(".quiz-container");
			})
		}

		function initVars() {
			vm.urlToShare = $location.absUrl();

			vm.programs = [
				{
					Id: 1,
					Title: 'Financial',
					Subtitle: 'education',
					Description: 'O curso FINANCIAL EDUCATION é focado no desenvolvimento das habilidades e competências relacionadas à gestão de ﬁnanças pessoais, compreensão de economia criativa, autocontrole e relações de produção e serviços.',
					Color: 'bg-aqua',
					Image: 'icon-education-white.svg',
					ProgramSkills: [1, 2, 3],
					Video: $sce.trustAsResourceUrl('https://www.youtube.com/embed/RPX3qhgSgrU'),
					FullName: 'Financial Education',
					Url: 'financial-education'

				}, {
					Id: 2,
					Title: 'Emotional',
					Subtitle: 'intelligence',
					Description: 'A solução educacional EMOTIONAL INTELLIGENCE é focada no desenvolvimento de competências e habilidades socioemocionais, tais como gestão das emoções, autocontrole, liderança e acompanhamento de foco e metas.',
					Color: 'bg-pink',
					Image: 'icon-intelligence-white.svg',
					ProgramSkills: [4, 5, 6],
					Video: $sce.trustAsResourceUrl('https://www.youtube.com/embed/io_qs3dwuTk'),
					FullName: 'Emotional Intelligence',
					Url: 'emotional-intelligence'
				}, {
					Id: 3,
					Title: 'Logical',
					Subtitle: 'thinking',
					Description: 'O curso LOGICAL THINKING traz a proposta de desenvolver a habilidade e a competência do raciocínio lógico-matemático, por meio de conteúdos apresentados de forma gamiﬁcada.',
					Color: 'bg-yellow',
					Image: 'icon-thinking-white.svg',
					ProgramSkills: [1, 2],
					Video: $sce.trustAsResourceUrl('https://www.youtube.com/embed/A3o_5hzbrvc'),
					FullName: 'Logical Thinking',
					Url: 'logical-thinking'
				}, {
					Id: 4,
					Title: 'Digital ',
					Subtitle: 'mindset',
					Description: 'A solução DIGITAL MINDSET explora conteúdos relacionados aos processos de programação e codiﬁcação de softwares, letramento digital, curadoria de conteúdo, inovação, transformação digital e diversos conteúdos fundamentais para o aprendizado nessa área.',
					Color: 'bg-green',
					Image: 'icon-mindset-white.svg',
					ProgramSkills: [7, 1, 2],
					Video: $sce.trustAsResourceUrl('https://www.youtube.com/embed/QeHak3ew774'),
					FullName: 'Digital Mindset',
					Url: 'digital-mindset'
				}
			];

			vm.skills = [
				{
					Id: 1,
					Title: 'Resolução de problemas',
					Description: 'A resolução de problemas é uma competência baseada no uso de métodos ordenados para encontrar as soluções adequadas para um contratempo. Essa abordagem está diretamente relacionada a um olhar analítico, que é a base para testar, combinar, modiﬁcar e gerar ideias capazes de atingir os objetivos iniciais.',
					Color: 'bg-yellow',
					Image: 'icon-problem.png',
					Icon: 'icon-circuits-white.png'
				},
				{
					Id: 2,
					Title: 'Pensamento crítico',
					Description: 'O pensamento crítico está relacionado ao olhar responsável e questionador para o mundo! Essa competência dialoga com a responsabilidade de ser um cidadão crítico, cujos posicionamentos e posturas sejam coerentes com o que a sociedade precisa hoje – e também no futuro.',
					Color: 'bg-dark-aqua',
					Image: 'icon-brain.png',
					Icon: 'icon-brain-white.png'
				},
				{
					Id: 3,
					Title: 'Colaboração',
					Description: 'Em uma sociedade cada vez mais conectada, a colaboração é uma palavra muito presente em nosso dia a dia! Atualmente, todos nós somos ligados em ambientes on e oﬀ-line o tempo todo, o que resulta em interações e parcerias constantes. Sendo assim, aprender a dialogar com o outro e construir pontes saudáveis de relacionamento será fundamental no futuro.',
					Color: 'bg-green',
					Image: 'icon-colaboration.png',
					Icon: 'icon-colaboration-white.png'
				},
				{
					Id: 4,
					Title: 'Comunicação',
					Description: 'A ato de se comunicar está relacionado à transmissão de informações por meio de linguagens verbais, textuais, corporais, artísticas, cientíﬁcas e tecnológicas. Essa competência está pautada principalmente na capacidade de diálogo e de expressão das nossas opiniões, sentimentos e impressões sobre o mundo à nossa volta, e na capacidade de ouvir o que as outras pessoas também têm a dizer.',
					Color: 'bg-marine',
					Image: 'icon-message.png',
					Icon: 'icon-message-white.png'
				},
				{
					Id: 5,
					Title: 'Liderança',
					Description: 'A liderança é uma qualidade associada a pessoas em quem todos se inspiram, e cujas ideias são fontes de estímulo e criatividade! Por isso, o ato de liderar está relacionado à criação de um ambiente saudável e positivo, no qual as pessoas se sentem motivadas e têm espaço para se desenvolverem no âmbito pessoal e proﬁssional. ',
					Color: 'bg-hot-pink',
					Image: 'icon-flag.png',
					Icon: 'icon-flag-white.png'
				},
				{
					id: 6,
					Title: 'Resiliência',
					Description: 'A palavra resiliência está associada à capacidade de uma pessoa de lidar com os próprios problemas e frustrações, adaptando-se às novidades sem ceder à pressão. Na contemporaneidade, marcada sobretudo por grandes transformações e inovações constantes, é necessário aprender a se moldar e manter-se calmo diante das adversidades ou do que ainda é desconhecido.',
					Color: 'bg-red',
					Image: 'icon-rocket-quiz.png',
					Icon: 'icon-rocket-white.png'
				},
				{
					Id: 7,
					Title: 'Criatividade',
					FullName: 'Logical Thinking',
					Description: 'A criatividade é considerada uma habilidade humana diretamente relacionada à nossa capacidade de inventar, reinventar e inovar. Sendo assim, as pessoas criativas são conhecidas pelo seu amplo repertório de conhecimentos e pela habilidade de sempre recorrer a ele para pensar fora da caixa!',
					Color: 'bg-orange',
					Image: 'icon-creativity2.png',
					Icon: 'icon-criativity-white.png'
				}
			];

		}

		function init() {
			if (!resultHash) {
				$state.go('default.quiz-intro');
				return
			}

			initVars();
			getAstronaut(resultHash);

			HelperService.clearLocalStorageData('LeadData');

			HelperService.scrollTo(".quiz-container");
		}


	}
}());